<template>
  <v-app>
    <Header></Header>
    <router-view></router-view>
    <v-dialog
      v-model="carSlider.showDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
      ref="sliderDialog"
    >
      <div class="dialog-wrapper">
        <div class="dialog-header">
          <div class="logo">
            <img
              src="./assets/images/360/logo-mitsubishi-black.png"
              alt="Mitsubishi"
            />
            <img src="./assets/images/360/logo.png" alt="OUTLANDER PHEV" />
            <p>360<sup>o</sup></p>
          </div>
          <div class="buttons">
            <v-btn
              :class="'mmc-red background'"
              v-ripple="{ class: 'ripple-red' }"
              @click="changeSliderPage()"
            >
              {{
                carSlider.togglePano
                  ? "Przejdź do widoku z zewnątrz"
                  : "Przejdź do widoku wnętrza"
              }}
            </v-btn>
            <i class="fas fa-times" @click="carSlider.showDialog = false"></i>
          </div>
        </div>
        <div class="dialog-body">
          <swiper
            :options="carSlider.slider"
            class="swiper slider-flex"
            ref="slider"
            @ready="onReady"
            @slideChange="updatePaginationIndex"
          >
            <swiper-slide class="slider-item">
              <p class="drag-to-rotate">Złap by obrócić</p>
              <div class="spin-wrapper">
                <div id="mySpinViewer"></div>
                <div class="navigation">
                  <i class="fas fa-angle-left" @click="prevSpin"></i>
                  <i class="fas fa-angle-right" @click="nextSpin"></i>
                  <i class="fas fa-undo-alt" @click="restartSpin"></i>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="slider-item">
              <p class="drag-to-rotate color-white">Złap by obrócić</p>
              <div id="myPanoViewer"></div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="form.showDialog" scrollable content-class="modal-dialog">
      <div class="modal-wrapper">
        <i class="fas fa-times-circle" @click="form.showDialog = false"></i>
        <h3>Kontakt on-line</h3>
        <div class="form-wrapper">
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field
              v-model="name"
              :rules="nameRules"
              label="Imię i Nazwisko"
              outlined
              required
              color="#e60013"
            ></v-text-field>
            <v-text-field
              v-model="phone"
              :rules="phoneRules"
              label="Telefon"
              outlined
              required
              type="number"
              color="#e60013"
            ></v-text-field>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              label="Adres e-mail"
              outlined
              required
              color="#e60013"
            ></v-text-field>
            <v-select
              :items="form.selectItems"
              v-model="select"
              :rules="[v => !!v || 'Wybór dealera jest wymagany.']"
              label="Wybierz dealera"
              outlined
              required
              color="#e60013"
            ></v-select>
            <v-checkbox
              v-model="checkbox"
              :rules="[
                v => !!v || 'Musisz zaakceptować warunki by kontynuuować.'
              ]"
              label="Rozumiem informację. Umów mnie na jazdę testową."
              required
              color="#e60013"
            ></v-checkbox>
          </v-form>
          <div class="form-info">
            <p>
              Pozostawiasz nam swoje dane osobowe tylko i wyłącznie w celu
              umówienia i realizacji usługi jazdy testowej.
            </p>
            <p>
              Pozostawienie danych jest dobrowolne, ale konieczne abyś mógł
              skorzystać z usługi jazdy testowej.
            </p>
            <p>
              Twoje dane osobowe będą przetwarzane tylko przez okres niezbędny
              do realizacji wskazanej powyżej usługi.
            </p>
            <p>
              W związku z usługą jazdy testowej i przekazanymi danymi, MMC Car
              Poland Sp. z o.o., 02-677 Warszawa, ul. Cybernetyki 10 oraz
              wybrany dealer są administratorami Twoich danych osobowych.
            </p>
            <p>
              Szczegółowe informacje dot. praw i obowiązków związanych z ochroną
              Twoich danych osobowych znajdziesz w
              <a
                href="https://www.mitsubishi.pl/polityka-prywatnosci"
                target="_blank"
                >Polityce prywatności</a
              >.
            </p>
          </div>
        </div>
        <div class="text-right">
          <v-btn
            :disabled="!valid"
            color="#e60013"
            class="mr-4"
            @click="validate"
            :class="{ showSpinner: this.formSubmit }"
          >
            <span class="text">
              Wyślij
              <i class="fas fa-caret-right"></i>
            </span>
            <span class="spinner">
              <v-progress-circular
                indeterminate
                color="#fff"
              ></v-progress-circular>
            </span>
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <v-dialog
      v-model="form.showErrorAlert"
      content-class="modal-dialog alert-modal"
    >
      <div class="modal-wrapper">
        <v-alert prominent type="error">
          <v-row align="center">
            <v-col class="grow"
              >Błąd przy wysłaniu formularza. Spróbuj ponownie.</v-col
            >
          </v-row>
          <i
            class="fas fa-times-circle"
            @click="form.showErrorAlert = false"
          ></i>
        </v-alert>
      </div>
    </v-dialog>
    <v-dialog
      v-model="form.showSuccessAlert"
      content-class="modal-dialog alert-modal"
    >
      <div class="modal-wrapper">
        <v-alert prominent type="success">
          <v-row align="center">
            <v-col class="grow">Formularz został wysłany. Dziękujemy.</v-col>
          </v-row>
          <i
            class="fas fa-times-circle"
            @click="form.showSuccessAlert = false"
          ></i>
        </v-alert>
      </div>
    </v-dialog>
  </v-app>
</template>

<script>
import "lightgallery.js/dist/css/lightgallery.min.css";
import "lightgallery.js/dist/js/lightgallery.min";
import "./assets/js/zoom.js";
import "./assets/js/fullscreen.js";
import "./assets/js/autoplay.js";
import "./assets/js/video.js";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { PanoViewer } from "@egjs/view360";
import { SpinViewer } from "@egjs/view360";
import { mapGetters } from "vuex";

import Vue from "vue";
import Header from "@/components/Header.vue";

export default Vue.extend({
  name: "App",
  data: function() {
    return {
      formSubmit: false,
      pano: PanoViewer,
      spin: SpinViewer,
      valid: true,
      name: "",
      nameRules: [v => !!v || "Imię i nazwisko jest wymagane."],
      phone: "",
      phoneRules: [v => !!v || "Numer telefonu jest wymagany"],
      email: "",
      emailRules: [
        v => !!v || "E-mail jest wymagany.",
        v => /.+@.+\..+/.test(v) || "Podaj prawidłowy adres e-mail"
      ],
      select: null,
      checkbox: false
    };
  },
  computed: {
    ...mapGetters({
      carSlider: "carSlider",
      form: "form"
    })
  },
  components: {
    swiper,
    swiperSlide,
    Header
  },
  methods: {
    validate() {
      if (!this.formSubmit) {
        this.formSubmit = true;
        this.$refs.form.validate();

        if (this.$refs.form.validate()) {
          const proxy = "https://cors-anywhere.herokuapp.com/";
          const url = `https://crm.mitsubishi-motors.pl/api/lead_add`;

          const formToSend = {
            key: "B23958207993D0A950CFE94C5D204D1D",
            departmentId: this.select.number,
            source: "Katalog multimedialny Mitsubishi PHEV",
            cc: "0",
            clientName: this.name,
            clientEmail: this.email,
            clientPhone: this.phone,
            brand: "Mitsubishi",
            model: "Eclipse Cross PHEV"
          };

          this.$http
            .post(proxy + url, formToSend, { useCredentails: true })
            .then(
              function(response) {
                this.form.showDialog = false;
                this.form.showSuccessAlert = true;
                this.formSubmit = false;
              },
              function(response) {
                this.form.showErrorAlert = true;
                this.formSubmit = false;
              }
            );
        } else {
          this.formSubmit = false;
        }
      }
    },
    prevSpin() {
      this.carSlider.currentAngle -= 10;
      this.spin.spinTo(this.carSlider.currentAngle, { duration: 0 });
    },
    nextSpin() {
      this.carSlider.currentAngle += 10;
      this.spin.spinTo(this.carSlider.currentAngle, { duration: 0 });
    },
    restartSpin() {
      this.carSlider.currentAngle = 0;
      this.spin.spinTo(0, { duration: 100 });
    },
    resizePano() {
      if (this.carSlider.initializedPano) {
        setTimeout(() => {
          this.pano.updateViewportDimensions("100%", "100%");
        }, 200);
      }
    },
    changeSliderPage() {
      this.$refs.slider.swiper.slideTo(this.carSlider.togglePano ? 0 : 1);
      this.carSlider.togglePano = !this.carSlider.togglePano;
    },
    onReady() {
      setTimeout(() => {
        if (!this.carSlider.initializedSpin) {
          this.carSlider.initializedSpin = true;
          this.spin = new SpinViewer(document.getElementById("mySpinViewer"), {
            imageUrl: require("@/assets/images/360/360-car.jpg"),
            rowCount: 32
          });
          this.$refs.slider.swiper.update();
        }
      }, 1000);
    },
    updatePaginationIndex() {
      if (this.$refs.slider.swiper.realIndex === 1) {
        if (!this.carSlider.initializedPano) {
          this.carSlider.initializedPano = true;
          this.pano = new PanoViewer(document.getElementById("myPanoViewer"), {
            image: require("@/assets/images/360/inside.jpg")
          });
        }
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizePano);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizePano);
  }
});
</script>

<style lang="scss">
@import "styles/main-style";

.modal-dialog {
  background-color: #6c6c6c;
  border-radius: 0 !important;

  .v-btn {
    &.showSpinner {
      .text {
        opacity: 0;
      }

      .spinner {
        display: block;
      }
    }

    .spinner {
      @include set-position(absolute, 50%, 50%, auto, auto);
      transform: translate(50%, -50%);
      display: none;
    }
  }
}

.modal-wrapper {
  position: relative;
  padding: 4rem;

  @media screen and (max-width: $screen-md) {
    padding: 2rem;
  }

  @media screen and (max-width: $screen-md) and (orientation: landscape) {
    padding: 1rem;
  }

  @media screen and (max-width: $screen-sm) {
    padding: 1rem;
  }

  .fa-times-circle {
    @include set-position(absolute, 1rem, 1rem, auto, auto);
    @include font-size-color(2.5rem, $mmc-red);
    line-height: 1;
    cursor: pointer;
  }

  h3 {
    @include font-size-color(1.9rem, $mmc-red);
    font-weight: 700;
    margin: 0 0 4rem;
    text-transform: uppercase;
    line-height: 1;
    padding-right: 2.5rem;

    @media screen and (max-width: $screen-md) {
      margin-bottom: 2rem;
    }

    @media screen and (max-width: $screen-md) and (orientation: landscape) {
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }

    @media screen and (max-width: $screen-sm) {
      margin-bottom: 1rem;
      font-size: 1.5rem;
    }
  }

  .form-wrapper {
    @include display-flex(flex, wrap);

    .v-form {
      @include size-flex(calc(50% - 2rem));

      @media screen and (max-width: $screen-md) {
        @include size-flex(calc(50% - 1rem));
      }

      @media screen and (max-width: $screen-md) and (orientation: landscape) {
        @include size-flex(100%);
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
      }

      fieldset {
        display: none;
      }

      .v-input__slot {
        background-color: $white;
        border-radius: 0;
      }

      .v-text-field input {
      }

      .v-label {
        color: #b2b2b2 !important;
      }

      .v-text-field--outlined .v-label--active {
        transform: translateY(-16px) scale(0.75);
      }

      .v-messages__message {
        color: $mmc-red;
      }

      .v-list-item__title {
        color: $black;
      }

      .v-input--checkbox {
        margin-top: 0;

        .v-input__slot {
          background-color: transparent;

          .v-label,
          .v-icon {
            color: $white !important;
          }
        }
      }
    }

    .form-info {
      @include size-flex(calc(50% - 2rem));
      margin-left: 4rem;

      @media screen and (max-width: $screen-md) {
        @include size-flex(calc(50% - 1rem));
        margin-left: 2rem;
      }

      @media screen and (max-width: $screen-md) and (orientation: landscape) {
        @include size-flex(100%);
        margin: 1rem 0 0;
      }

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        margin: 1rem 0 0;
      }

      p {
        @include font-size-color(1rem, $white);
        font-weight: 400;
        margin-bottom: 1rem;

        a {
          color: $mmc-red;
        }
      }
    }
  }

  .v-btn {
    background-color: $mmc-red !important;
    margin-bottom: 1rem;

    &:disabled {
      i {
        color: rgba(0, 0, 0, 0.26) !important;
      }
    }

    i {
      margin-right: 0;
    }
  }
}

.alert-modal {
  z-index: 303 !important;
  max-width: 500px !important;

  @media screen and (max-width: $screen-es) {
    max-width: 300px !important;

    .v-alert__content {
      font-size: 0.85rem;
      line-height: 1.15;
    }
  }

  .modal-wrapper {
    padding: 0;

    .v-alert {
      @include margin-padding(0, 3.5rem 1rem);
    }

    .fa-times-circle {
      color: $white;
    }
  }
}

.dialog-wrapper {
  @include display-flex(flex, wrap);
  background-color: #ffffff;
  padding: var(--page-offset) calc(2 * var(--page-offset));
  align-content: center;

  @media screen and (max-width: $screen-sm) {
    padding: var(--page-offset);
  }

  .dialog-header {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    align-content: center;
    justify-content: space-between;
    margin-bottom: 1rem;

    .logo {
      @include display-flex(flex, wrap);
      align-content: center;

      img {
        display: inline-block;
        align-self: center;

        &:first-of-type {
          max-width: 5rem;
          margin-right: 1rem;

          @media screen and (max-width: $screen-lg) {
            max-width: 4rem;
          }

          @media screen and (max-width: $screen-md) {
            max-width: 3rem;
            max-height: 2rem;
          }

          @media screen and (max-width: $screen-xs) {
            max-width: 2rem;
            margin-right: 0.3rem;
          }
        }

        @media screen and (max-width: $screen-lg) {
          max-width: 11rem;
        }

        @media screen and (max-width: $screen-md) {
          max-width: 7rem;
        }

        @media screen and (max-width: $screen-es) {
          max-width: 5rem;
        }
      }

      p {
        @include font-size-weight(2.6rem, 900);
        display: inline-block;
        color: $black;
        margin: 0 0 0 1.5rem;
        line-height: 1.5;

        @media screen and (max-width: $screen-lg) {
          font-size: 2rem;
        }

        @media screen and (max-width: $screen-md) {
          font-size: 1.3rem;
          margin: 0 0 0 0.75rem;
        }

        @media screen and (max-width: $screen-es) {
          font-size: 1rem;
        }

        @media screen and (max-width: $screen-xs) {
          display: none;
        }

        sup {
          color: $black;
        }
      }
    }

    .buttons {
      @include display-flex(flex, wrap);
      align-content: center;

      .v-btn {
        @media screen and (max-width: $screen-lg) {
          padding: 0.6rem 1rem !important;
          font-size: 1rem !important;
        }

        @media screen and (max-width: $screen-md) {
          padding: 0.4rem !important;
          font-size: 0.8rem !important;
          letter-spacing: 0 !important;
        }

        @media screen and (max-width: $screen-xs) {
          width: auto !important;
          font-size: 0.45rem !important;
        }
      }

      i {
        @include font-size-color(4rem, $mmc-red);
        margin: 0 1.5rem;
        cursor: pointer;
        vertical-align: middle;

        @media screen and (max-width: $screen-lg) {
          font-size: 3rem;
          margin: 0 1rem;
        }

        @media screen and (max-width: $screen-md) {
          font-size: 2rem;
          margin: 0 0.5rem;
        }

        @media screen and (max-width: $screen-xs) {
          font-size: 1.5rem;
          margin: 0.1rem 0 0 0.5rem;
        }
      }
    }
  }

  .dialog-body {
    @include display-flex(flex, wrap);
    @include size-flex(100%);

    .swiper {
      width: 100%;
    }

    .slider-item {
      color: $black;
      height: calc(100vh - 87px + (-2 * var(--page-offset)));
      align-content: center;

      @media screen and (max-width: $screen-lg) {
        height: calc(100vh - 68px + (-2 * var(--page-offset)));
      }

      @media screen and (max-width: $screen-sm) {
        height: calc(100vh - 51px + (-2 * var(--page-offset)));
      }

      @media screen and (max-width: $screen-xs) {
        height: calc(100vh - 46px + (-2 * var(--page-offset)));
      }

      .spin-wrapper {
        @include size-flex(100%);
        justify-content: center;
        position: relative;

        #mySpinViewer {
          @include z-index(relative, 1);
          @include set-size(1200px !important, 800px !important);
          margin: 0 auto;

          @media screen and (max-height: $screen-height-lg) {
            @include set-size(900px !important, 600px !important);
          }

          @media screen and (max-width: $screen-xl) {
            @include set-size(900px !important, 600px !important);
          }

          @media screen and (max-width: $screen-lg) {
            @include set-size(750px !important, 500px !important);
          }

          @media screen and (max-width: $screen-md) {
            @include set-size(500px !important, 333px !important);
          }

          @media screen and (max-width: $screen-es) {
            @include set-size(300px !important, 200px !important);
          }

          > div {
            height: 100%;
            padding-bottom: 0 !important;
          }
        }
      }

      #myPanoViewer {
        @include set-size(100%, 100%);
        cursor: grab;
        outline: none;

        canvas {
          outline: none;
        }
      }

      .drag-to-rotate {
        @include set-position(absolute, 1rem, auto, auto, 0rem);
        @include font-size-weight(1rem, 500);
        color: #aeaeae;
        text-transform: uppercase;
        z-index: 99;

        &.color-white {
          color: $white;
          left: 1rem;
        }
      }

      .navigation {
        @include set-position(fixed, auto, 0, 20%, auto);
        @include display-flex(flex, wrap);
        @include size-flex(100%);
        text-align: right;
        align-items: center;
        justify-content: flex-end;
        z-index: 1;

        @media screen and (max-width: $screen-sm) {
          bottom: var(--page-offset);
        }

        i {
          @include font-size-color(3rem, $mmc-red);
          padding-right: 1rem;
          cursor: pointer;

          &.fa-undo-alt {
            font-size: 2rem;
          }

          &:last-of-type {
            margin-right: 0;
          }
        }
      }

      .car-colors {
        @include size-flex(100%);
        text-align: center;

        @media screen and (max-width: $screen-es) {
          @include display-flex(flex, wrap);
          justify-content: center;
        }

        .item {
          @include set-background(no-repeat, center center, cover);
          @include set-size(3rem, 3rem);
          display: inline-block;
          margin-right: 0.5rem;
          border: 1px solid $slider-description;
          cursor: pointer;
          box-shadow: 0 0 5px 1px transparent;
          transition: all 0.3s ease-in-out;

          @media screen and (max-width: $screen-es) {
            @include set-size(auto, auto);
            @include size-flex(calc(20% - 0.75rem));
            display: block;
            margin: 0 1rem 1rem 0;

            &:nth-of-type(4n + 4) {
              margin-right: 0;
            }

            &::after {
              content: "";
              display: block;
              padding-bottom: 100%;
            }
          }

          &:last-of-type {
            margin-right: 0;
          }

          &.active {
            border-color: $mmc-red;
            box-shadow: 0 0 5px 1px $mmc-red;
          }
        }
      }
    }
  }
}
</style>
